export const GET_USER_INFO = "GET_USER_INFO";
export const GET_USER_INFO_SUCCESS = "GET_USER_INFO_SUCCESS";
export const GET_USER_INFO_FAILED = "GET_USER_INFO_FAILED";
export const GET_SELECTED_CODE = "GET_SELECTED_CODE";
export const GET_GUID = "GET_GUID";
